<template>
  <div class="col-lg-4 col-md-6 mb-4">
    <div class="offer-item" :class="[theme, iconColor ? 'offer-item--custom' : '']" :style="iconColor ? { '--icon-color': iconColor } : null">
      <div class="offer-item__header">
        <div class="offer-item__header-inner">
          <div class="offer-item__icon">
            <div v-if="svgCode" v-html="svgCode" class="offer-item__svg"></div>
            <img v-else-if="iconUrl" :src="iconUrl" :alt="offer.title || ''" />
          </div>
          <div class="offer-item__animation"></div>
        </div>
      </div>
      <h5 class="offer-item__title">
        {{ offer.title }}
      </h5>
      <div class="offer-item__text editor" v-html="offer.description">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    offer: {
      required: true,
      type: Object,
    },
    index: {
      required: true,
      type: Number,
    },
    svgCode: {
      required: false,
      type: String,
      default: null,
    },
    iconUrl: {
      required: false,
      type: String,
      default: null,
    },
    iconColor: {
      required: false,
      type: String,
      default: null,
    },
  },
  computed: {
    theme() {
      let i = this.index;
      if (i == 0 || i == 3) {
        return "offer-item--red";
      }
      if (i == 1 || i == 4) {
        return "offer-item--yellow";
      }
      return "offer-item--black";
    },
  },
};
</script>
<style scoped>
.offer-item__icon img { max-width: 100%; max-height: 100%; object-fit: contain; }
.offer-item__svg { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
</style>
